import { Input as AntdInput, InputProps } from 'antd'

export const Input = (props: InputProps) => <AntdInput {...props} />
